import { useQuery } from '@tanstack/react-query';
import { ChatMessage } from '@/models/ChatMessage';
import BackendClient from '@/api/backendClient.ts';
import { BackendSuccessResponse } from '@/types/response/Api/BackendSuccessResponse';
import { BackendErrorResponse } from '@/types/response/Api/BackendErrorResponse';
import { transformBackendErrors } from '@/utils/transformBackendErrors.ts';

type Filters =
  | {
      chatId?: string | null;
    }
  | undefined;

const useChatMessages = (enabled: boolean = true, filters: Filters = undefined) => {
  const queryKey = ['chat_messages', filters?.chatId];

  const queryFn = async () => {
    return getChats(filters);
  };

  return useQuery({
    queryKey,
    queryFn,
    enabled,
    staleTime: 1000 * 60 * 5,
  });
};

export default useChatMessages;

async function getChats(filters: Filters): Promise<ChatMessage[]> {
  try {
    const response = await BackendClient.get<BackendSuccessResponse<ChatMessage[]>>('/api/chat/all-messages', {
      params: {
        chat_id: filters?.chatId,
      },
    });

    return response.data.data;
  } catch (error: any) {
    if (error.response && error.response.data) {
      const errorResponse = error.response.data as BackendErrorResponse;

      throw new Error(transformBackendErrors(errorResponse).join(', '));
    }

    throw new Error(error.message ?? 'An error occurred while fetching chat messages.');
  }
}
